import { addDays, differenceInDays, differenceInHours, format, isToday, isTomorrow, setHours, max, startOfMonth, startOfYear, sub, subDays, endOfMonth, endOfYear, isPast, differenceInMinutes } from "date-fns";
import { formatDateLocal } from "./script";
import { formatISO } from "date-fns";
import { startOfWeek } from "date-fns";
import { endOfWeek } from "date-fns";
import { parseApiDateOrDateTime } from "./dateParsing";


export function isDateInThePast(date) {
    if (date) {
        const d = parseApiDateOrDateTime(date)
        if (!d) return null
        const result = isPast(d)

        return result
    }

    return null
}
export function isDateToday(date) {
    if (date) {
        const d = parseApiDateOrDateTime(date)
        if (!d) return null
        const result = isToday(d)

        return result
    }

    return null
}

export function isDateTomorrow(date) {
    if (date) {
        const result = isTomorrow(new Date(2014, 9, 7, 14, 0))

        return result
    }

    return null
}

export function isDatePlusDays(date, difference ) {
    if (date) {
        const d = parseApiDateOrDateTime(date)
        if (!d) return null
        const result = differenceInDays(
            d,
            new Date()
        )

        return result <= difference
    }

    return null
}

export function getDaysDifference(date) {
    if (date) {
        // let todayMidnight = setHours(new Date(), 0)
        // let targetDateMidnight = setHours(new Date(date), 0)
        // const result = differenceInDays(
        //     targetDateMidnight,
        //     todayMidnight
        // )

        // return result

        //  with hours 
        const d = parseApiDateOrDateTime(date)
        if (!d) return null
        const result = differenceInHours(
            d,
            new Date()
        )

        return Math.ceil(result/24)       
    }

    return null
}

export function getDaysDifferenceSimple(date) {
    if (date) {
        let todayMidnight = setHours(new Date(), 0)
        const d = parseApiDateOrDateTime(date)
        if (!d) return null
        let targetDateMidnight = setHours(d, 0)
        const result = differenceInDays(
            targetDateMidnight,
            todayMidnight
        )

        return result       
    }

    return null
}

export function getDaysDifferenceAbs(date) {
    if (date) {
        return Math.abs(getDaysDifference(date))       
    }

    return null
}

export function dueDateDifference(date) {
    if (getDaysDifference(date) < 4) {
        

        if (getDaysDifference(date) < 2) {
            if (getDaysDifference(date) < 1) {
                return 'border_red'
            } else {
                return 'border_orange'
            }
        } else {
            return 'border_yellow'
        }
    } 

    return null
}

export function dueDateDifferenceText(date) {

    if (date) {
        if (getDaysDifference(date) < 6) {
        

            if (getDaysDifference(date) < 1) {
                if (getDaysDifference(date) < 0) {                
                    return <span style={{color: 'var(--red)'}}>Overdue {Math.abs(getDaysDifference(date))} days</span>
                } else {
                    return <span style={{color: 'var(--red)'}}>Due today</span>
                }
            } else {
                return <span style={{color: 'var(--orange1)'}}>Due in {getDaysDifference(date)} days</span>
            }
        } 

        return <span>Due {formatDateLocal(date)}</span>
    }

    return null
}

export function datesMessageGlobal(date) {   

    if (date) {
        let diff = getDaysDifference(date)

        if (diff < 1) {
            if (diff < 0) {   
                if (diff < -1) {
                    return <span>{Math.abs(getDaysDifference(date))} days ago</span>
                } else {
                    return <span>Yesterday</span>
                }          
                
            } else {
                return <span>Today</span>
            }
        } else {
            if (diff < 2) {
                return <span>Tomorrow</span>
            } else {
                return <span>In {getDaysDifference(date)} days</span>
            }
        }
    }

    return null
}

// Formats a date (string or Date) as M/d EEE, e.g., 10/17 Fri, using date-fns
export function formatDateShort(date) {

    if (!date) return '';

    let d = typeof date === 'string' ? parseApiDateOrDateTime(date) : date;
    if (isNaN(d)) return '';

    return format(d, 'M/d EEE');
}

// export function addDaysAndReturnNewDate(days) {
//     const result = addDays(new Date(), days)

//     return result
// }  

/**
 * Returns a new Date after adding N *business* days (Monday-Friday) to today.
 * Skips weekends. Today is not counted; tomorrow is "add 1".
 * @param {number} days 
 * @returns {Date}
 */
export function addDaysAndReturnNewDate(days) {
    if (!days || isNaN(days)) return new Date();

    let date = new Date();
    let count = 0;
    while (count < days) {
        date = addDays(date, 1);
        const dayOfWeek = date.getDay();
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
            count++;
        }
    }
    return date;
}

export function getThisWeek(date, minMax) {
    const start = startOfWeek(date, {weekStartsOn: 1});
    const end = endOfWeek(date, {weekStartsOn: 1})
    if (minMax) {
        return {
            min: start,
            max: end
        }
    }
    return `${formatISO(start, { representation: 'date' })}|${formatISO(end, { representation: 'date' })}`
}

export function getLastWeek(date, minMax) {
    const todayLastWeek = subDays(date)
    const start = startOfWeek(todayLastWeek, {weekStartsOn: 1});
    const end = endOfWeek(todayLastWeek, {weekStartsOn: 1})
    if (minMax) {
        return {
            min: start,
            max: end
        }
    }
    return `${formatISO(start, { representation: 'date' })}|${formatISO(end, { representation: 'date' })}`
}

export function getThisMonth(date, minMax) {
    const start = startOfMonth(date, {weekStartsOn: 1});
    const end = endOfMonth(date, {weekStartsOn: 1})
    if (minMax) {
        return {
            min: start,
            max: end
        }
    }
    return `${formatISO(start, { representation: 'date' })}|${formatISO(end, { representation: 'date' })}`
}

export function getLastMonth(minMax) {
    const date1MonthsAgo = sub(new Date(), {
        months: 1
    });

    const start = startOfMonth(date1MonthsAgo, {weekStartsOn: 1});
    const end = endOfMonth(date1MonthsAgo, {weekStartsOn: 1})
    if (minMax) {
        return {
            min: start,
            max: end
        }
    }
    return `${formatISO(start, { representation: 'date' })}|${formatISO(end, { representation: 'date' })}`
}

export function getLast6Months(minMax) {
    const date6MonthsAgo = sub(new Date(), {
        months: 6
    });
    const today = new Date()
    const start = startOfMonth(date6MonthsAgo, {weekStartsOn: 1});
    const end = endOfMonth(today, {weekStartsOn: 1})
    if (minMax) {
        return {
            min: start,
            max: end
        }
    }
    return `${formatISO(start, { representation: 'date' })}|${formatISO(end, { representation: 'date' })}`
}

export function getThisYear(date, minMax) {
    const start = startOfYear(date, {weekStartsOn: 1});
    const end = endOfYear(date, {weekStartsOn: 1})

    if (minMax) {
        return {
            min: start,
            max: end
        }
    }
    return `${formatISO(start, { representation: 'date' })}|${formatISO(end, { representation: 'date' })}`
}


export function dateTimeIsPastPeriod(date, time, period) {

    if (date && time && period) {
        const now = new Date()
        const dateTime = new Date(date + "T" + time)
        const diff = differenceInMinutes(now, dateTime)
        return diff > period
    }

    return false
}

export function dayOneStatusClass(workq_call_follow_up) {

    if (workq_call_follow_up) {
        if (workq_call_follow_up.day_1_status == "No Answer" || workq_call_follow_up.day_1_status == "Cancelled") {
            return true
        }
    }

    return null
}